import * as React from 'react'
import { SVGProps } from 'react'
const SvgAccountStatement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M11.111.43c0-.16.192-.239.304-.127l2.504 2.505a.178.178 0 0 1-.126.303h-2.504a.178.178 0 0 1-.178-.178V.43Z"
      fill="#00D37E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.778.444C1.778.2 1.977 0 2.222 0h7.556c.245 0 .444.199.444.444v3.112c0 .245.2.444.445.444h3.11c.246 0 .445.199.445.444v11.112a.444.444 0 0 1-.444.444H2.222a.444.444 0 0 1-.444-.444V.444Zm2.694.828c0-.222.197-.383.417-.383.22 0 .417.161.417.383v.23h.27c.22 0 .417.161.417.383s-.197.383-.417.383H4.66c-.16 0-.27.113-.27.23s.11.23.27.23h.458c.598 0 1.104.437 1.104.996 0 .5-.404.902-.916.982v.244c0 .222-.198.383-.417.383-.22 0-.417-.16-.417-.383v-.23h-.27c-.22 0-.417-.16-.417-.383 0-.221.197-.382.417-.382h.916c.16 0 .27-.114.27-.23 0-.117-.11-.231-.27-.231H4.66c-.598 0-1.104-.436-1.104-.996 0-.5.404-.901.916-.981v-.245Zm2.195 4.95a.444.444 0 0 0 0 .89H12a.444.444 0 1 0 0-.89H6.667ZM3.556 9.778c0-.246.199-.445.444-.445h8a.444.444 0 1 1 0 .89H4a.444.444 0 0 1-.444-.445ZM4 12.444a.444.444 0 0 0 0 .89h8a.444.444 0 1 0 0-.89H4Z"
      fill="#00D37E"
    />
  </svg>
)
export default SvgAccountStatement
